import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AuthApp from './AuthApp';
import Landing2 from './components/Landing2/Landing2';
import GDPR from './components/GDPR/GDPR';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import NotFound from './components/NotFound/NotFound';
import { blogPosts } from './data/blogPosts';
import './App.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Routes>
            <Route exact path="/" element={<Landing2/>}/>
            <Route exact path="/app" element={<AuthApp/>}/>
            <Route exact path="/gdpr" element={<GDPR/>}/>
            <Route exact path="/blog" element={<BlogList posts={blogPosts}/>}/>
            <Route exact path="/blog/:slug" element={<BlogPost posts={blogPosts}/>}/>
            <Route path="*" element={<NotFound/>}/>
        </Routes>
      </Router>
    </HelmetProvider>
  </React.StrictMode>,
);
